<template>
	<div>
		<entity-card v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity }" :entity.sync="entity"></entity-card>
	</div>
</template>

<script>
	import TestQuestion from "@/models/testQuestion.model.vue"
	import EntityCard from "@/components/Espresso/EntityCard.vue"
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import { Tabs, Modal } from '@/components'

	export default {
		components: {
			EntityCard,
			PaginatedSearch,
			Tabs,
			Modal,
		},
		data() {
			return {
				entity: {
					id: this.$route.params.questionId,
					articleId: this.$route.params.id,
				},
				schema: TestQuestion.getSchema(),
				showModal: false,
			}
		},
		methods: {
			async createEntity(entity) {
				this.entity = await TestQuestion.create(entity);
				this.$router.replace(`/artigos/${this.entity.articleId}/pergunta/${this.entity.id}`);
				return this.entity;
			},
			async readEntity(entityId) {
				const response = await TestQuestion.getInfo(entityId);
				return response;
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				return TestQuestion.updateInfo(dataToUpdate);
			},
			async deleteEntity(entityId) {
				await TestQuestion.remove(entityId);
				this.$router.push("/artigos");
			},
		},
	};
</script>

<style>
.tab-pane-1,
.tab-pane-2 {
  width: 100% !important;
}

.modal-container {
	box-shadow: none !important;
}
</style>